/**
 * SOLID Review
 * S — Strong. 17 lines: find the `#root` DOM node (throwing a clear fatal error if absent) and mount
 *     `<App>` inside `StrictMode`. A single, minimal bootstrap responsibility.
 * O — Strong. Nothing to extend; a true entry point. N/A /
 * L — N/A — no inheritance hierarchy.
 * I — Strong. No props/interface surface at all.
 * D — Strong. Depends only on `react`, `react-dom/client` and the local `App` — nothing from
 *     application/infrastructure/domain layers.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { reportRenderError } from './composition/frontendRoot';

const container = document.getElementById('root');
if (!container) {
  throw new Error(
    '[Meyer Live 3D] Fatal: Root DOM element with id "root" was not found. ' +
      'Ensure index.html contains <div id="root"></div>.'
  );
}

// Client error reporting (2026-10-10): a render an error boundary caught is reported too. An error no boundary
// caught reaches the window's own listener (React reports it with `reportError`), so it is not hooked here.
createRoot(container, { onCaughtError: reportRenderError }).render(
  <StrictMode>
    <App />
  </StrictMode>
);
